import { Button, Col, Divider, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { H6 } from "../../../../AbstractElements";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import { poCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const BidDetialsPage = (props) => {
  const { id } = useParams();
  const { dispatch } = props;
  const history = useNavigate();
  const [vendorBidDetails, setVendorBidDetails] = useState();
  const [bidDetails, setBidDetails] = useState();
  const [vendor_bid_items, setVendorBidItems] = useState([]);
  const columns = [
    {
      title: "S.no",
      key: "s_no",
      dataIndex: "s_no",
      width: 100,
    },
    {
      title: "Item",
      key: "boq_item",
      render: (data) => <span>{data?.bid_item?.item?.boq_item ?? ""}</span>,
      width: 680,
    },
    {
      title: "Quantity",
      key: "quantity",
      render: (data) => <span>{data?.quantity ?? ""}</span>,
    },
    {
      title: "Price",
      key: "price",
      render: (data) => (
        <span>{data?.bid_unit_price ? data?.bid_unit_price : ""}</span>
      ),
    },
    {
      title: "Tax value",
      key: "tax_value",
      render: (data) => (
        <span>{data?.tax_value > -1 ? data?.tax_value : ""}</span>
      ),
    },
    {
      title: "Tax type",
      key: "tax_type",
      render: (data) => (
        <>
          {data?.tax_type == "igst" && "IGST"}
          {data?.tax_type == "cgst_sgst" && "CGST & SGST"}
          {data?.tax_type == "none" && "None"}
        </>
      ),
    },
    {
      title: "Amount",
      key: "amount",
      render: (data) => {
        var total =
          Number(data?.bid_item?.quantity) * Number(data?.bid_unit_price ?? 0);
        var price = total;
        var tax = data?.tax_value;
        price += price * 0.01 * tax;
        return <span>₹ {price?.toFixed(2)}</span>;
      },
    },
  ];
  useEffect(() => {
    const getVendorBidDetails = async () => {
      try {
        await axios.get(`apiV1/vendor-bid/?id=${id}`).then((resp) => {
          console.log("Bid details", resp);
          const data = resp?.data[0];
          getBidDetails({ bidId: data?.bid });
          setVendorBidDetails(data);
          setVendorBidItems(data?.vendor_bid_items);
        });
      } catch (error) {
        console.log("cancelled", error);
      }
    };
    getVendorBidDetails();
  }, []);

  const getBidDetails = async ({ bidId }) => {
    try {
      await axios.get(`apiV1/bid-report/?bid_id=${bidId}`).then((resp) => {
        setBidDetails(resp?.data);
      });
    } catch (error) {
      console.log("cancelled", error);
    }
  };

  const createPoWithSelectedItems = () => {
    let project_selected_items =
      props.settings.selected_budget_items?.project_selected_items;
    const selected_items = vendor_bid_items?.map((item_obj) => {
      if (item_obj?.sub_item) {
        return {
          ...item_obj?.bid_item?.sub_item,
          quantity: item_obj?.bid_item?.quantity,
          unit_po_price: item_obj?.bid_unit_price,
          tax_value: item_obj?.tax_value,
          discount: item_obj?.discount ?? 0,
          tax_type: item_obj?.tax_type,
        };
      } else {
        return {
          ...item_obj?.bid_item?.item,
          quantity: item_obj?.bid_item?.quantity,
          unit_po_price: item_obj?.bid_unit_price,
          tax_value: item_obj?.tax_value,
          discount: item_obj?.discount ?? 0,
          tax_type: item_obj?.tax_type,
        };
      }
    });
    const currentProjectSelectedItems = {
      project_id: props.settings?.project?.id,
      selected_items: selected_items,
      vendor_id: vendorBidDetails?.vendor?.id,
    };
    if (project_selected_items) {
      const indexOfProject = project_selected_items.findIndex(
        (element) => element?.project_id == props.settings?.project?.id
      );
      if (indexOfProject > -1) {
        project_selected_items[indexOfProject] = currentProjectSelectedItems;
      } else {
        project_selected_items.push(currentProjectSelectedItems);
      }
    } else {
      project_selected_items = [];
      project_selected_items.push(currentProjectSelectedItems);
    }
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "selected_budget_items",
        value: {
          project_selected_items: project_selected_items,
        },
      },
    });
    history(`/app/project/powo/new`);
  };
  const getTotalBasicPrice = () => {
    let total = 0;
    vendor_bid_items?.map((item) => {
      let totalItemPrice = item?.quantity * item?.bid_unit_price;
      total += totalItemPrice;
    });
    return total?.toFixed(2);
  };

  const getTotalGSTPrice = () => {
    let total = 0;
    vendor_bid_items?.map((item) => {
      let totalItemPrice = item?.quantity * item?.bid_unit_price;
      totalItemPrice = (totalItemPrice * item?.tax_value) / 100;

      total += totalItemPrice;
    });
    return total?.toFixed(2);
  };

  return (
    <React.Fragment>
      <Card
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
          padding: "18px 15px",
          marginBottom: "15px",
        }}
      >
        <div className="d-flex align-items-center">
          <ArrowLeftOutlined
            style={{ fontSize: "25px" }}
            onClick={() => {
              history(-1);
            }}
          />
          <div
            style={{
              marginBottom: "1px",
              marginLeft: "10px",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            Vendor Bid Details
          </div>
        </div>
        <div>
          {/* {poCreationAndEditGranted(props.settings?.user) && (
            <Button
              type="primary"
              onClick={() => {
                createPoWithSelectedItems();
              }}
            >
              Raise PO for this bid
            </Button>
          )} */}
        </div>
      </Card>
      <Card>
        <Row gutter={24} className="mt-3">
          <Col sm={11}>
            <CardBody>
              <div className="">
                <H6>Bid Details</H6>
              </div>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Bid Number
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{bidDetails?.bid_number}</Col>
                  </Row>
                </Col>
              </Row>
              {/* <Row gutter={16}>
                <Col sm={5} md={5}>
                  Address
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>32, rafg colog cadf ,banglore</Col>
                  </Row>
                </Col>
              </Row> */}
              {/* <Row gutter={16} >
                      <Col sm={5} md={5}>
                        PIN Code
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}></Col>
                        </Row>
                      </Col>
                    </Row> */}
              {/* <Row gutter={16}>
                <Col sm={5} md={5}>
                  GST
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>r43t54rqtewfgdsr23154</Col>
                  </Row>
                </Col>
              </Row> */}
            </CardBody>
          </Col>
          <Col sm={11}>
            <CardBody>
              <div className="">
                <H6>Vendor Details</H6>
              </div>
              <Row gutter={24} className="">
                <Col sm={12} md={12}>
                  Vendor Name
                </Col>
                <Col sm={12} md={12}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{vendorBidDetails?.vendor?.name}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={12} md={12}>
                  Address
                </Col>
                <Col sm={12} md={12}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>
                      {vendorBidDetails?.vendor?.billing_address}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={12} md={12}>
                  Contact Details
                </Col>
                <Col sm={12} md={12}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>
                      {vendorBidDetails?.vendor?.contact},{" "}
                      {vendorBidDetails?.vendor?.email}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={12} md={12}>
                  GST
                </Col>
                <Col sm={12} md={12}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>{vendorBidDetails?.vendor?.gst}</Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Col>
        </Row>
        <Divider orientation="horizontal" />
        <CardBody>
          <Table
            columns={columns}
            dataSource={vendor_bid_items}
            scroll={{ x: "100%" }}
          />
        </CardBody>
      </Card>
      <Card>
        <Divider orientation="horizontal" />
        <div className="row p-5">
          <div className="col"></div>
          <div className="col">
            <div className="d-flex justify-content-between">
              <div className="bold">Total Basic Price</div>
              <div className="">₹{getTotalBasicPrice()}</div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="bold">Total GST Price</div>
              <div className="">₹{getTotalGSTPrice()}</div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="bold">Total Bid Price</div>
              <div className="">₹{vendorBidDetails?.total_bid_price}</div>
            </div>
          </div>
        </div>
      </Card>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(BidDetialsPage);
